import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl, ValidationErrors, ControlContainer, NgForm } from '@angular/forms';

import { BHPService } from '../_services/bhp.service';
import { InjectionService } from '../_services/injection.service';

import { UserSubmittableDataGridComponent } from '../user-submittable-data-grid/user-submittable-data-grid.component';

import { InjectionPressureDataBatch } from '../_models/injection-pressure-data-batch';

@Component({
  selector: 'app-bhp-data-grid',
  templateUrl: './bhp-data-grid.component.html',
  styleUrls: ['./bhp-data-grid.component.css']
})
export class BhpDataGridComponent extends UserSubmittableDataGridComponent implements OnInit {

  constructor(
    public bhpService: BHPService,
    public injectionService: InjectionService,
    formBuilder: FormBuilder
  ) {
    super(formBuilder, injectionService);

    this.DateFieldName = "MeasurementDate";

    
  }

  ngOnInit(): void {
  }

}
